import React, { useCallback, useContext, useState,useEffect, useRef, useMemo } from 'react';
import C from './Constants.js';
import { useSelector } from 'react-redux';
import DragEnteredGridCellCover from './DragEnteredGridCellCover';

import ImpactedColumnsOnGridResizeHint from './ImpactedColumnsOnGridResizeHint';

import CellWidthResizer from './CellWidthResizer';

import GridCellBorder from './GridCellBorder';
import GridCellOutline from './GridCellOutline';
import GridValueContainer from './GridValueContainer';
import useEditorDispatch from './useEditorDispatch';

import CropDropLayer from './CropDropLayer';

import { CropDragContext } from './CropDragProvider';

import { 
	CropAdjustmentContext,
	GridCellContext,
} from './Contexts';


const DEFAULT_STYLE = {
	position:'relative',
	textAlign:'center', 
	height:'100%',
	padding:0,
	margin:0,
	fontSize:12,
	userSelect:'none',
	verticalAlign:'middle',
	minHeight:C.MINIMUM_ROW_HEIGHT,
}

function GridCell({
	displayPlaceholder,
	editable,
	figurePanelId,
	textBounds,
	rotatedRectHeight,
	angle,
	contents,
	_id,
	pxWidth,
	cellLocationY,
	cellLocationX,

	computedStyle,
	cell,
	tableOutlineShowing,
	setDontUnselectCells,
	selectedCells,
	onCropDrop,
	currentWidths,
	widths,
}){




	const cellLocation = useMemo(() => {
		return ([cellLocationY,cellLocationX])},[cellLocationX,cellLocationY]
	);




	if( !figurePanelId ){
		throw Error("GridCell was not given a figurePanelId.");
	}

	const tdRef = useRef(null);


	const onFigureInteractionEvent = useEditorDispatch();


	//const [tdBounds,setTdBounds] = useState({});


	const { cropIdsBeingDragged } = useContext(CropDragContext);

	let isDraggingCrop = cropIdsBeingDragged?.length > 0;

	useEffect(() => { 
		//let newBounds = ref.current.getBoundingClientRect();
		if( tdRef && tdRef.current ){
			let newTdBounds = tdRef.current.getBoundingClientRect();
			//setTdBounds(newTdBounds);
		}
		//setBounds(newBounds);
	}, [tdRef,angle]);


	let { value  } = contents;



	/*
	if( selected && temporaryCellValue !== null && temporaryCellValue !== undefined ){
		value = temporaryCellValue;
	}
	*/



	let { bottomBorderWidth, topBorderWidth, leftBorderHeight, rightBorderHeight, borderBottom, borderLeft, borderRight, borderTop, bottomBracketHeight, leftBracketWidth, rightBracketWidth, topBracketHeight, ...textStyle } = computedStyle;



	let valueToRender = value;
	


	if( value === undefined ){
		debugger;
	}
	if( value.valueType === 'bandAnnotation' ){
		valueToRender = contents;
	}


	const onCellInteractionEvent = useCallback((eventObject) => {
		let bubbledObject = {
			...eventObject,
			cell:{x:cellLocationX,y:cellLocationY},
			cellLocation
		}

		if( onFigureInteractionEvent ){
			onFigureInteractionEvent(bubbledObject)
		}

	},[cellLocationX,cellLocationY,cellLocation,onFigureInteractionEvent])

	
	let renderedValueProps = useMemo(() => ({
		textStyle,
		editable,
		tableOutlineShowing,
		figurePanelId,
		textBounds,
		rotatedRectHeight,
		value:valueToRender,
		width:pxWidth,
		gridCellId:_id,
		cellLocation,
		//tdBounds, 
		tdRef,
		cell
	}),[
      onFigureInteractionEvent,
      editable,
      tableOutlineShowing,
      figurePanelId,
      textBounds,rotatedRectHeight,valueToRender,
		pxWidth
		,_id,cellLocation,
      //tdBounds,
      tdRef,cell])



	//row spacer above (from rotation), row spacer below (from rotation) and general row spacing
	let numberOfSpacerRowsBetweenEachFigureRow = 3 + 2 * Number(!!isDraggingCrop);

	let rowSpan = cell.h;
	if( cell.h > 1 ){
		rowSpan = cell.h * (1 + numberOfSpacerRowsBetweenEachFigureRow) - 2 ; // minus the row spacer at the end.
	}


	let tdStyle = {
		//...textStyle,
		position:'relative',
		//alignItems:'stretch',

		maxWidth:(currentWidths?currentWidths[cell.x]:widths[cell.x]),

		minWidth:(currentWidths?currentWidths[cell.x]:widths[cell.x]),
		width:pxWidth,
		height:18,
		//height:'100%',
		background:'white',
		//background:'green',
	}

	

	/*if( cropResizeInfo ){
		//tdStyle.pointerEvents = 'none';
	}*/

	//return <td></td>

	return (

		<GridCellContext.Provider value={cellLocation}>
			<td 
				valueType={value.valueType}
				objecttype="GridCell"
				imageCrop={value.valueType === "crop"}
				cell={cell.y+'-'+cell.x}
				ref={tdRef}
				id={"grid-"+cell.y+"-"+cell.x}
				onClick={e=>{

					onFigureInteractionEvent({
						_source:"GRID_CELL",
						type:"click",
						event:e,
						itemType:"cell",
						cell:[cell.y,cell.x],
					})
				}}
				style={tdStyle}
				rowSpan={rowSpan}
				colSpan={cell.w}>

				<GridValueContainer 
					onCellInteractionEvent={onCellInteractionEvent}
					{...renderedValueProps}/>
				


				{tableOutlineShowing && <GridCellOutline/>}


				<GridCellBorder {...{ 
					computedStyle, 
					cell:cellLocation 
				}}/>

				{editable !== false && (<CellWidthResizer {...{
					figurePanelId,
					cell,
					widths
				}}/>)}

				{editable!==false && 
				<ImpactedColumnsOnGridResizeHint {...{
					cell,
					width:pxWidth,
					value
				}}/>}


				


				<CropDropLayer cell={cell}/>

				<DragEnteredGridCellCover editable={editable} cell={cell}/>

			</td>

		</GridCellContext.Provider>

	)

}

export default React.memo(GridCell);

